__turbopack_context__.v({
  "container": "partner-logos-module-scss-module__x9TWVG__container",
  "description": "partner-logos-module-scss-module__x9TWVG__description",
  "partner-logo": "partner-logos-module-scss-module__x9TWVG__partner-logo",
  "partner-logos": "partner-logos-module-scss-module__x9TWVG__partner-logos",
});
